// 3rd
import { Model } from '@vuex-orm/core';
import {
    API_ENDPOINT_POST_FEEDBACK,
    LOADER_SUBMIT_FEEDBACK
} from '../utils/constants';
import {
    api,
    authHeaders
} from '../utils/api';

export default class Order extends Model {
    static entity = 'orders';

    static fields() {
        return {
            id: this.attr(null),
            created_at: this.attr(null),
            delivery_address: this.attr(null),
            order_items: this.attr(null),
            order_number: this.attr(null),
            total_price: this.attr(null),
            user_id: this.attr(null),
        }
    }

    static getDetails(id) {
        let orderItemDetails = null;
        const order = Order.all();
        order.forEach((o) => {
            o.order_items.forEach((orderItem) => {
                if (orderItem.id === Number(id)) {
                    orderItemDetails = orderItem;
                }
            });
        });

        return orderItemDetails;
    }

    static getShippingInfo(id) {
        let itemToReturn = null;
        const order = Order.all();
        order.forEach((o) => {
            o.order_items.forEach((orderItem) => {
                if (orderItem.id === Number(id)) {
                    itemToReturn = o;
                }
            });
        });
        return itemToReturn;
    }

    static async submitFeedbackForm(form) {
        Order.store().dispatch('wait/start', LOADER_SUBMIT_FEEDBACK);
        const feedback = await api.post(API_ENDPOINT_POST_FEEDBACK, form, authHeaders());
        Order.store().dispatch('wait/end', LOADER_SUBMIT_FEEDBACK);
        return feedback;
    }
}
